import { Controller } from "stimulus"
import { Turbo } from "@hotwired/turbo-rails"
export default class extends Controller {
    //static values = { seconds: Number };
    static targets = ["pulldown","searchinput","category"];

    connect() {

    }

    // Ticket 757: search by name and optional category; show the category in each option.
    search() {
        const query = (this.hasSearchinputTarget ? this.searchinputTarget.value : "").toLowerCase()
        const category = this.hasCategoryTarget ? this.categoryTarget.value : ""
        const params = new URLSearchParams()
        params.set("q", query)
        if (category) params.set("category", category)
        fetch("/search_exercise_types?" + params.toString())
            .then((response) => response.json())
            .then((data) => {
                // Ticket 758: groepeer zoekresultaten op categorie in optgroups
                const groups = {};
                data.forEach(x => {
                    const cat = (x["category"] && x["category"].length) ? x["category"] : "Overig";
                    (groups[cat] = groups[cat] || []).push(x);
                });
                var html = "";
                Object.keys(groups).sort().forEach(cat => {
                    html = html + "<optgroup label='" + cat + "'>";
                    groups[cat].forEach(x => {
                        html = html + "<option value='" + x["id"] + "'>" + x["name"] + "</option>";
                    });
                    html = html + "</optgroup>";
                });
                this.pulldownTarget.innerHTML = html;
            });
    }
    
    
}
